import axios from 'axios';

import {
  GET_TV_THREAD,
  GET_TV_CHANNEL,
  GET_TV_CHANNELS,
  GET_TV_CHANNELS_BY_COUNTRY,
} from '../constants';

export const getCatchUpThread = response => ({
  type: GET_TV_THREAD,
  response,
});

export const getTvThreadSuccess = response => ({
  type: GET_TV_THREAD,
  response,
});

// export const getTvThread = id => dispatch => (
//   axios.get(`/channels/guide/${id}/${moment().format('DDMMYYYY')}`)
//     .then((response) => {
//       let start = moment().subtract(1, 'hour').unix();

//       if (response.data.data.guides.length) {
//         const { guides, currentId } = response.data.data;
//         start = moment(guides.find(guide => guide.id === +currentId).startTime).unix();
//       }

//       axios.get(`/channels/thread/${id}`, { withCredentials: true })
//         .then((res) => {
//           const data = {
//             status: res.status,
//             data: res.data.data.map(item => (
//               Object.assign(...item, {
//                 ...item,
//                 threadAddress: item.threadAddress.replace('playlist', `index-${start}-now`),
//               })
//             )),
//           };
//           return dispatch(getTvThreadSuccess(data));
//         });
//     })
//     .catch((error) => {
//       const data = {
//         status: 0,
//         data: [],
//       };
//       if (error.response) {
//         data.status = error.response.status;
//       } else if (error.request) {
//         data.status = 0;
//       } else {
//         data.status = 0;
//       }
//       dispatch(getTvThreadSuccess(data));
//     })
// );
export const getTvThread = id => dispatch => (
  axios.get(`/channels/thread/${id}`, { withCredentials: true })
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getTvThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
        data.vouchers = error.response.data.vouchers;
      } else {
        data.status = 0;
      }
      dispatch(getTvThreadSuccess(data));
    })
);


export const getTvChannelSuccess = response => ({
  type: GET_TV_CHANNEL,
  response,
});

export const getTvChannel = id => dispatch => (
  axios.get(`/channels/show/${id}`, { withCredentials: true })
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getTvChannelSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTvChannelSuccess(data));
    })
);

export const getTvByCountrySuccess = response => ({
  type: GET_TV_CHANNELS_BY_COUNTRY,
  response,
});

export const getTvByCountry = () => dispatch => (
  axios.get('/countrychannels', { withCredentials: true })
    .then((response) => {
      const data = {
        status: response.status,
        mediaHost: response.data.mediaHost,
        data: response.data.data,
      };
      return dispatch(getTvByCountrySuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTvByCountrySuccess(data));
    })
);

export const getTvSuccess = response => ({
  type: GET_TV_CHANNELS,
  response,
});

export const getTv = () => dispatch => (
  axios.get('/channels/channels', { withCredentials: true })
    .then((response) => {
      const data = {
        status: response.status,
        mediaHost: response.data.mediaHost,
        data: response.data.data,
      };
      return dispatch(getTvSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTvSuccess(data));
    })
);
